import { fetchWrapper, objectToQueryParams } from '../utils';

const baseUrl = process.env.REACT_APP_BASE_API + 'client';

export const create = async (form) => {
  const url = `${baseUrl}/purchases`;
  return await fetchWrapper.post(url, form);
}

export const createFee = async (form) => {
  const url = `${baseUrl}/purchases/fee`;
  return await fetchWrapper.post(url, form);
}

export const createWithoutPayment = async (form) => {
  const url = `${baseUrl}/purchases/without-payment`;
  return await fetchWrapper.post(url, form);
}

export const get = async (filters) => {
  const url = `${baseUrl}/purchases?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}

export const getAvailableServices = async (filters) => {
  const url = `${baseUrl}/services/available?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}

export const getServicesHistory = async (filters) => {
  const url = `${baseUrl}/services/history?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}

export const requestService = async (form) => {
  const url = `${baseUrl}/services`;
  return await fetchWrapper.post(url, form);
}

export const getProductsToPay = async (filters) => {
  const url = `${baseUrl}/purchases/to-pay/fees?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}

export const getPurchasesToPay = async (filters) => {
  const url = `${baseUrl}/purchases/to-pay?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}

export const getPurchasesProducts = async (filters) => {
  const url = `${baseUrl}/purchases/products?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}

export const getPurchasesProductsPendings = async (filters) => {
  const url = `${baseUrl}/purchases/products/pendings?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}

export const confirmReceived = async (form) => {
  const url = `${baseUrl}/services/confirm`;
  return await fetchWrapper.post(url, form);
}

export const getSyspagoOTP = async (form) => {
  const url = `${baseUrl}/payments/syspago/getOTP`;
  return await fetchWrapper.post(url, form);
}

export const confirmSyspagoOTP = async (form) => {
  const url = `${baseUrl}/payments/syspago/send`;
  return await fetchWrapper.post(url, form);
}

export const getBNCOTP = async (form) => {
  const url = `${baseUrl}/payments/bnc/getOTP`;
  return await fetchWrapper.post(url, form);
}

export const confirmBNCOTP = async (form) => {
  const url = `${baseUrl}/payments/bnc/send`;
  return await fetchWrapper.post(url, form);
}

export const faceIdentityToken = async (form) => {
  const url = `${baseUrl}/face-identity-token`;
  return await fetchWrapper.post(url, form);
}

export const verifyVehicleCard = async (form) => {
  const url = `${baseUrl}/verify-vehicle-card`;
  return await fetchWrapper.post(url, form);
}

export const updateVehicleData = async (form) => {
  const url = `${baseUrl}/update-vehicle-data`;
  return await fetchWrapper.post(url, form);
}

export const deleteVehicleData = async (form) => {
  const url = `${baseUrl}/delete-vehicle-data`;
  return await fetchWrapper.post(url, form);
}

export const validateVehicleData = async (form) => {
  const url = `${baseUrl}/validate-vehicle-data`;
  return await fetchWrapper.post(url, form);
}